export default {
  startLoading({ commit }, loaderMessage) {
    commit('ADD_LOADING', loaderMessage)
  },
  endLoading({ commit }, loaderMessage) {
    commit('REMOVE_LOADING', loaderMessage)
  }
}
